export default {"src":"/_next/static/media/Monza.fceb162e.svg","height":1052,"width":750,"blurWidth":0,"blurHeight":0};